var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hParamsType)?_c('h-reg-basic',{on:{"saveInfo":_vm.saveBasicInfo}}):_vm._e(),(_vm.tParamsType)?_c('t-reg-basic',{on:{"saveInfo":_vm.saveBasicInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }